import { theme } from '~/theme';

export const useSxStyles = () => {
  return {
    userProfile: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: '#fafafa',
      padding: theme.spacing(1, 2),
      boxShadow: `${theme.shadows[1].replaceAll('),', ') inset,')} inset`,
    },
  };
};
